import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Backdrop, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import Header from '../../../../header';
import Footer from '../../../../footer';
import CustomInput from '../../../../../components/customInput';
import CustomButton from '../../../../../components/customButton';
import { useSelector } from 'react-redux';
import { langSelector } from '../../../../../store/langSlice';
import getEnvironement, { getLang } from '../../../../../environnement';
import CustomSelect from '../../../../../components/customSelect';
import { useNavigate } from 'react-router-dom';

function InscriptionConfirm({
  open,
  handleClose
}) {
  const navigate = useNavigate();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{paddingBottom: '0px'}}
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <p className='text-2xl sm:text-3xl font-regular font-inter text-red'>Votre inscription a bien été enregistrée</p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div className='flex justify-end px-5 w-full'>
          <div
            className='group rounded-[20px] py-2 sm:py-3 mb-5 cursor-pointer bg-primary hover:bg-primaryDark w-[180px]'
            onClick={() => {
              handleClose();
              navigate('/');
            }}
          >
            <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>D'accord</p>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default function InscriptionAtelier({
  activeItem,
  typeInscrit
}) {
  const [nom, setNom] = useState('');
  const [email, setEmail] = useState('');
  const [tel, setTel] = useState('');
  const [atelier1, setAtelier1] = useState('');
  const [atelier2, setAtelier2] = useState('');
  const [atelier3, setAtelier3] = useState('');
  const [atelier4, setAtelier4] = useState('');
  const [atelierProceduraux, setAtelierProceduraux] = useState('');

  const [atelier1Items, setAtelier1Items] = useState([]);
  const [atelier2Items, setAtelier2Items] = useState([]);
  const [atelier3Items, setAtelier3Items] = useState([]);
  const [atelier4Items, setAtelier4Items] = useState([]);
  const [atelierProcedurauxItems, setAtelierProcedurauxItems] = useState([]);

  const [nomError, setNomError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [telError, setTelError] = useState('');
  const [atelier1Error, setAtelier1Error] = useState('');
  const [atelier2Error, setAtelier2Error] = useState('');
  const [atelier3Error, setAtelier3Error] = useState('');
  const [atelier4Error, setAtelier4Error] = useState('');
  const [atelierProcedurauxError, setAtelierProcedurauxError] = useState('');

  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openInscriptionConfirm, setOpenInscriptionConfirm] = useState(false);

  const lang = useSelector(langSelector);

  const sendInscription = async () => {
    const url = `${getEnvironement().API_URL}/inscriptionAteliersFirstWorldCup`;
    let typeInscription = '';
    if (typeInscrit === 'résidents') {
      typeInscription = 'résident';
    } else if (typeInscrit === 'spécialistes') {
      typeInscription = 'spécialiste';
    } else {
      typeInscription = 'étudiant';
    }
    const data = {
      lang,
      typeInscrit: typeInscription,
      nom,
      email,
      tel,
      atelier1,
      atelier2,
      atelier3,
      atelier4,
      atelierProceduraux,
    };

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }
    setOpenBackdrop(true);
    await axios.post(url, data, config)
      .then(() => setOpenBackdrop(false))
      // .then(() => toast.success(getLang(lang).firstWorldCup.soumissionSuccess))
      .then(() => setOpenInscriptionConfirm(true))
      .then(() => {
        setNom('');
        setEmail('');
        setTel('');
        setAtelier1('');
        setAtelier2('');
        setAtelier3('');
        setAtelier4('');
        setAtelierProceduraux('');
        
        setNomError('');
        setEmailError('');
        setTelError('');
        setAtelier1Error('');
        setAtelier2Error('');
        setAtelier3Error('');
        setAtelier4Error('');
        setAtelierProcedurauxError('');
      })
      .catch((err) => {
        console.log(err);
        setOpenBackdrop(false);
        if (err.response.data.errors) {
          toast.error(getLang(lang).firstWorldCup.soumissionError);
          err.response.data.errors.nom ? setNomError(err.response.data.errors.nom[0]) : setNomError('');
          err.response.data.errors.email ? setEmailError(err.response.data.errors.email[0]) : setEmailError('');
          err.response.data.errors.tel ? setTelError(err.response.data.errors.tel[0]) : setTelError('');
          err.response.data.errors.atelier1 ? setAtelier1Error(err.response.data.errors.atelier1[0]) : setAtelier1Error('');
          err.response.data.errors.atelier2 ? setAtelier2Error(err.response.data.errors.atelier2[0]) : setAtelier2Error('');
          err.response.data.errors.atelier3 ? setAtelier3Error(err.response.data.errors.atelier3[0]) : setAtelier3Error('');
          err.response.data.errors.atelier4 ? setAtelier4Error(err.response.data.errors.atelier4[0]) : setAtelier4Error('');
          err.response.data.errors.atelierProceduraux ? setAtelierProcedurauxError(err.response.data.errors.atelierProceduraux[0]) : setAtelierProcedurauxError('');
        }
      });
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (typeInscrit === 'étudiants') {
      setAtelier1Items([
        {id: 0, value: '', label: 'Aucun'},
        {id: 1, value: 'Examen neurologique de l’enfant', label: 'Examen neurologique de l’enfant'},
        {id: 2, value: 'Let’s check for  the ventilation', label: 'Let’s check for  the ventilation'},
        {id: 3, value: 'Atelier dermatologie de l’enfant', label: 'Atelier dermatologie de l’enfant'},
      ]);
      setAtelier2Items([
        {id: 0, value: '', label: 'Aucun'},
        {id: 1, value: 'Réanimation néonatale', label: 'Réanimation néonatale'},
        {id: 2, value: 'NFS en pédiatrie', label: 'NFS en pédiatrie'},
        {id: 3, value: 'Radio thorax en pédiatrie', label: 'Radio thorax en pédiatrie'},
        {id: 4, value: 'Gestion de la 1ère convulsion', label: 'Gestion de la 1ère convulsion'},
      ]);
      setAtelier3Items([
        {id: 0, value: '', label: 'Aucun'},
        {id: 1, value: 'Cri incessant du nourisson', label: 'Cri incessant du nourisson'},
        {id: 2, value: 'Envenimement', label: 'Envenimement'},
        {id: 3, value: 'Examen du nouveau-né hors la salle de naissance', label: 'Examen du nouveau-né hors la salle de naissance'},
      ]);
      setAtelierProcedurauxItems([
        {id: 0, value: '', label: 'Aucun'},
        {id: 1, value: 'Ponction lombaire', label: 'Ponction lombaire'},
        {id: 2, value: ' Voix Intra osseuse', label: ' Voix Intra osseuse'},
        {id: 3, value: 'Sondage urinaire', label: 'Sondage urinaire'},
        {id: 4, value: 'Ponction pleurale', label: 'Ponction pleurale'},
        {id: 5, value: 'Sonde naso-gastrique/ Aspiration', label: 'Sonde naso-gastrique/ Aspiration'},
        {id: 6, value: 'Dépistage Luxation congénitale de la hanche', label: 'Dépistage Luxation congénitale de la hanche'},
        {id: 7, value: 'Gestion des voies aériennes', label: 'Gestion des voies aériennes'},
        {id: 8, value: 'Soins infirmiers', label: 'Soins infirmiers'},
      ]);
    } else if (typeInscrit === 'spécialistes' || typeInscrit === 'résidents') {
      setAtelier2Items([
        {id: 0, value: '', label: 'Aucun'},
        {id: 1, value: 'Placer un KTVO', label: 'Placer un KTVO'},
        {id: 2, value: 'Echographie transfontanellaire du nouveau-né', label: 'Echographie transfontanellaire du nouveau-né'},
        {id: 3, value: 'Echographie cardiaque néonatale', label: 'Echographie cardiaque néonatale'},
        {id: 4, value: 'Echographie pulmonaire', label: 'Echographie pulmonaire'},
      ]);
      setAtelier3Items([
        {id: 0, value: '', label: 'Aucun'},
        {id: 1, value: 'Let’s check for the ventilation', label: 'Let’s check for the ventilation'},
        {id: 2, value: 'Soins de développement', label: 'Soins de développement'},
        {id: 3, value: 'L’oralité ', label: 'L’oralité '},
        {id: 4, value: 'Les Calculs nutritionnels', label: 'Les Calculs nutritionnels'},
        {id: 5, value: 'Kiné respiratoire de l’enfant', label: 'Kiné respiratoire de l’enfant'},
        {id: 6, value: 'Myélogramme', label: 'Myélogramme'},
        {id: 7, value: 'Ponction transfontanellaire', label: 'Ponction transfontanellaire'},
      ]);
      setAtelierProcedurauxItems([
        {id: 0, value: '', label: 'Aucun'},
        {id: 1, value: 'Intubation + Instillation de surfactant', label: 'Intubation + Instillation de surfactant'},
        {id: 2, value: 'Ventilation avec le pièce en T', label: 'Ventilation avec le pièce en T'},
        {id: 3, value: 'Fond d’œil', label: 'Fond d’œil'},
        {id: 4, value: 'Mesure de la pression intra-cranienne', label: 'Mesure de la pression intra-cranienne'},
      ]);
    }
  }, [typeInscrit])

  return (
    <div>
      <ToastContainer />
      <InscriptionConfirm
        open={openInscriptionConfirm}
        handleClose={() => setOpenInscriptionConfirm(false)}
      />
      <Backdrop
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          color: '#A31732',
          zIndex: 2000
        }}
        open={openBackdrop}
        onClick={() => setOpenBackdrop(false)}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Header activeItem={activeItem} />
      <div className='3xl:flex 3xl:justify-center'>
        <div className='3xl:w-[1200px] px-10 my-10'>
          <p className='font-inter text-primary font-medium text-2xl sm:text-3xl mb-6'>{`Inscrivez-vous aux ateliers réservés aux ${typeInscrit}`}</p>
          <CustomInput
            isArabicStyle={false}
            type='text'
            placeholder='Nom'
            value={nom}
            setValue={setNom}
            isError={nomError !== ''}
            error={nomError}
          />
          <CustomInput
            isArabicStyle={false}
            type='email'
            placeholder='E-mail'
            value={email}
            setValue={setEmail}
            isError={emailError !== ''}
            error={emailError}
          />
          <CustomInput
            isArabicStyle={false}
            type='tel'
            placeholder='Numéro du téléphone'
            value={tel}
            setValue={setTel}
            isError={telError !== ''}
            error={telError}
          />
          {typeInscrit === 'étudiants' && (
            <CustomSelect
              isArabicStyle={false}
              items={atelier1Items}
              placeholder='Ateliers jeudi 03/07/2025'
              value={atelier1}
              setValue={setAtelier1}
              isError={atelier1Error !== ''}
              error={atelier1Error}
            />
          )}
          <>
            <CustomSelect
              isArabicStyle={false}
              items={atelier2Items}
              placeholder='Ateliers vendredi 04/07/2025'
              value={atelier2}
              setValue={setAtelier2}
              isError={atelier2Error !== ''}
              error={atelier2Error}
            />
            <CustomSelect
              isArabicStyle={false}
              items={atelier3Items}
              placeholder='Ateliers samedi 05/07/2025'
              value={atelier3}
              setValue={setAtelier3}
              isError={atelier3Error !== ''}
              error={atelier3Error}
            />
          </>
          {typeInscrit !== 'étudiants' && (
            <CustomSelect
              isArabicStyle={false}
              items={atelier4Items}
              placeholder='Ateliers dimanche 06/07/2025'
              value={atelier4}
              setValue={setAtelier4}
              isError={atelier4Error !== ''}
              error={atelier4Error}
            />
          )}
          
          <CustomSelect
            isArabicStyle={false}
            items={atelierProcedurauxItems}
            placeholder='Ateliers procéduraux'
            value={atelierProceduraux}
            setValue={setAtelierProceduraux}
            isError={atelierProcedurauxError !== ''}
            error={atelierProcedurauxError}
          />
          <CustomButton
            isArabicStyle={false}
            value={'S\'inscrire'}
            handelClick={sendInscription}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}
